import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class NotificationMessagesService {
  readonly recountNotificationsEvent = new BehaviorSubject<number>(0);
  readonly showNotificationMessage = new BehaviorSubject<boolean>(false);
}
